module.exports = __webpack_public_path__ + "static/img/kh-21.7c7597a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-21.png
// module id = St1A
// module chunks = 5